import React, { useEffect, useState, useCallback } from "react";
import Table from "../../../Utils/Table/Table1";
import {
  symbolholdoff,
  inrsymbolholdoff,
  updatesymbolstatus,
} from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";

const Holdoff = () => {


  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [activeSeg, setActiveSeg] = useState("USD");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [segmentFilter, setSegmentFilter] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [segmentOptions, setSegmentOptions] = useState([]);


  const loadData = useCallback(async () => {
    try {
      const fetchApi =
        activeSeg === "INR"
          ? () => inrsymbolholdoff(page, search, segmentFilter, rowsPerPage)
          : () => symbolholdoff(page, search, rowsPerPage);

      const response = await fetchApi();
      const list = response?.data || [];

      setData(list);
      setTotalPages(response?.totalPages || 1);

      if (activeSeg === "INR") {
        const uniqueSegments = [...new Set(list.map((i) => i.exch_seg))];
        setSegmentOptions(uniqueSegments);
      }
    } catch (error) {
      console.log("Load error:", error);
    }
  }, [page, search, activeSeg, segmentFilter, rowsPerPage]);

  useEffect(() => {
    loadData();
  }, [loadData]);


  const updateStatus = async (e, symbol) => {
    const newStatus = e.target.checked ? 1 : 0;

    const result = await Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (!result.isConfirmed) {
      e.target.checked = !e.target.checked;
      return;
    }

    try {
      const response = await updatesymbolstatus({ symbol, user_active_status: newStatus });

      if (response.status) {
        Swal.fire("Saved!", "", "success");
        loadData();
      }
    } catch {
      Swal.fire("Error", "Something went wrong", "error");
      e.target.checked = !e.target.checked;
    }
  };

  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ row, index }) => (page - 1) * rowsPerPage + index + 1,
    },

    ...(activeSeg === "INR"
      ? [{ Header: "Trade Symbol", accessor: "tradesymbol" }]
      : []),

    { Header: "Symbol", accessor: "symbol" },
    { Header: "Segment", accessor: "exch_seg" },
    { Header: "Lot Size", accessor: "lotsize" },

    ...(activeSeg === "USD"
      ? [
        {
          Header: "Status",
          accessor: "status",
          Cell: ({ row }) => (
            <label className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={row.status === 1}
                onChange={(e) => updateStatus(e, row.symbol)}
              />
            </label>
          ),
        },
      ]
      : []),
  ];

  return (

    <div className="container-fluid mt-5">
      <div className="card transaction-table" style={{ background: "#F7F7F7" }}>

        <div className="card-header border-0 flex-wrap ">
          <h4 className="card-title ">⏸️ Hold Off</h4>

          <div className="btn-group ">
            {["USD", "INR"].map((seg) => (
              <button
                key={seg}
                type="button"
                className={`btn ${activeSeg === seg ? "btn-primary" : "btn-outline-primary"
                  }`}
                onClick={() => {
                  setActiveSeg(seg);
                  setPage(1);
                }}
              >
                {seg === "USD" ? "$ USD Wallet" : "₹ INR Wallet"}
              </button>
            ))}
          </div>
        </div>

        <div className="d-flex align-items-center ms-4 mb-3 gap-4">
          <div className="mt-3">
            <label className="fw-semibold me-2 d-block">🔍 Search :</label>
            <input
              style={{ width: "250px" }}
              className="form-control"
              type="text"
              placeholder="Search by Symbol / Segment..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>

          {activeSeg === "INR" && (
            <div className="mt-3">
              <label className="fw-semibold me-2 ">📌 Segment :</label>
              <select
                style={{ width: "200px" }}
                className="form-select"
                value={segmentFilter}
                onChange={(e) => {
                  setSegmentFilter(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">All</option>
                <option value="NSE">NSE</option>
                <option value="BSE">BSE</option>
                <option value="MCX">MCX</option>
                <option value="CDS">CDS</option>
                {segmentOptions.map((seg, i) => (
                  <option key={i} value={seg}>
                    {seg}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="card-body px-3">
          <Table
            columns={columns}
            data={data}
            page={page}
            totalPages={totalPages}
            onPageChange={setPage}
            initialRowsPerPage={rowsPerPage}
            onRowsPerPageChange={setRowsPerPage}
          />
        </div>

      </div>
    </div>
  );
};

export default Holdoff;
